import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { AiTaskQueue, AiTaskQueueStatusArrayValues } from '../../helpers/schema';

export const schema = z.object({
  taskId: z.string().min(1),
  personaId: z.string().min(1).optional(), // If not provided, uses task's assigned persona
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  queueItem: Selectable<AiTaskQueue>;
};

export const enqueueAiTask = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/ai-queue/enqueue`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
